import { del, get, patch, post, put, toQueryParams } from '@/lib/http';
import { endpoints } from './endpoints';
import type {
  AppSettings,
  AppUser,
  CreateUserRequest,
  Page,
  PageRequest,
  Role,
  UpdateUserRequest,
  UpdateUserRolesRequest,
  UserStatus,
} from '@/types';

export interface UserQuery extends PageRequest {
  role?: Role | 'ALL';
  status?: UserStatus | 'ALL';
  search?: string;
}

export const userApi = {
  list: (query: UserQuery = {}) =>
    get<Page<AppUser>>(endpoints.users.list, {
      params: toQueryParams({ page: 0, size: 10, ...query }),
    }),

  byId: (id: number) => get<AppUser>(endpoints.users.byId(id)),

  create: (body: CreateUserRequest) => post<AppUser, CreateUserRequest>(endpoints.users.list, body),

  update: (id: number, body: UpdateUserRequest) =>
    put<AppUser, UpdateUserRequest>(endpoints.users.byId(id), body),

  /** Replaces the whole role set in one call — see PUT /users/:id/roles. */
  setRoles: (id: number, body: UpdateUserRolesRequest) =>
    put<AppUser, UpdateUserRolesRequest>(endpoints.users.roles(id), body),

  setStatus: (id: number, status: UserStatus) =>
    patch<AppUser, { status: UserStatus }>(endpoints.users.status(id), { status }),

  remove: (id: number) => del<void>(endpoints.users.byId(id)),
};

export const settingsApi = {
  get: () => get<AppSettings>(endpoints.settings),
  update: (body: AppSettings) => put<AppSettings, AppSettings>(endpoints.settings, body),
};
